import {Procedure} from "./procedure";
import {Utils} from "../utils";
import {BaseModel} from "./base-model";
import {Company} from "./company";

export class Equipment extends BaseModel {

  protected static self = Equipment;

  id: string;
  manufacturer: string;
  name: string;
  description: string;
  imageUrl: string;
  company: Company;
  procedures: Procedure[];

  public validateModel() {
    return !Utils.isEmpty(this.manufacturer) &&
      !Utils.isEmpty(this.name) &&
      !Utils.isEmpty(this.description);
  }

  public validateSkills() {
    return true; // TODO
  }

  public validate(): boolean {
    return this.validateModel() && this.validateSkills();
  }

}
